export enum Language {
  Norwegian = 'nb',
  Swedish = 'sv',
  English = 'en',
}
